import "./headline.scss"

export function Headline (props: {label: String}) {
    return <svg width="340" height="75" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_490:64)" id="gno-headline-container">
                <rect id="gno-overworld-headline-button" x="0" y="0" width="340" height="70" rx="38" fill="#59277F"/>
                <text 
                    id="gno-textid" 
                    x={340/2}
                    y={(70/2)+2} 
                    fill="white"
                    dominantBaseline="middle"
                    textAnchor="middle"
                    fontSize={32}
                    fontWeight={400}
                    >
                        {props.label}
                    </text>
            </g>
            <linearGradient id="MyGradient" gradientTransform="rotate(90)">
                <stop offset="0%" stopColor="#59277f" />
                <stop offset="100%" stopColor="#7a43a4" />
            </linearGradient>
            <linearGradient id="MyReverseGradient" gradientTransform="rotate(90)">
                <stop offset="0%" stopColor="#7a43a4" />
                <stop offset="100%" stopColor="#59277f" />
            </linearGradient>
    </svg>
}